module.exports = __webpack_public_path__ + "img/9788936456467.1e1ec0f2.jpg";